<div class="container">
    <section>
        <div class="d-flex justify-content-between pl-5 pr-5">
            <div>
                <mat-form-field appearance="outline" class="col-md-3">
                    <mat-label>Select Centre</mat-label>
                    <mat-select [(ngModel)]="selectedCentre" (selectionChange)="onCentreSelected()">
                        <mat-option *ngFor="let c of (centres$|async)" [value]="c">{{c.centreName}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="children$" class="col-md-3">
                    <mat-label>Select Child</mat-label>
                    <mat-select [(ngModel)]="selectedChild">
                        <mat-option *ngFor="let c of (children$|async)" [value]="c">{{c.firstName}} {{c.lastName}}</mat-option>
                    </mat-select>
                </mat-form-field>





                &nbsp;<mat-form-field appearance="outline">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
                    <input matEndDate [(ngModel)]="endDate" placeholder="End date">
                </mat-date-range-input>
                <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

            </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-3" >
                    <mat-label>Submitted By</mat-label>
                    <mat-select [(ngModel)]="submittedBy" (selectionChange)="applyfilters()" >
                        <mat-option [value]=null> All Counsellors </mat-option>
                        <mat-option *ngFor="let e of counsellors$|async" [value]="e.userName">{{e.userName}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <button mat-mini-fab (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
                <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>
            </div>


        </div>

    </section>


<!--    <div class="card p-2">-->

<!--        <div class="ngxTableHeader">-->
<!--            <ul class="header-buttons-left ms-0 mb-0">-->
<!--                <li class="dropdown">-->
<!--                    <h2>Follow Up Assessment </h2>-->
<!--                </li>-->
<!--                <li class="dropdown m-l-20">-->
<!--                    <label for="search-input"><i class="material-icons search-icon">search</i></label>-->
<!--                    <input placeholder="Search" type="text" class="browser-default search-field"-->
<!--                           (keyup)='applyFilter($event)' aria-label="Search box" #input>-->
<!--                </li>-->
<!--            </ul>-->
<!--            <ul class="header-buttons mr-2">-->
<!--                <li>-->
<!--                    <button mat-mini-fab color="primary">-->
<!--                        <mat-icon class="col-white" (click)="OpenDialog()">add</mat-icon>-->
<!--                    </button>-->
<!--                </li>-->
<!--                &lt;!&ndash;      <li>&ndash;&gt;-->
<!--                &lt;!&ndash;        <div class="export-button m-l-10" matTooltip="XLSX">&ndash;&gt;-->
<!--                &lt;!&ndash;          <img src="assets/images/icons/xlsx.png" alt=""/>&ndash;&gt;-->
<!--                &lt;!&ndash;        </div>&ndash;&gt;-->
<!--                &lt;!&ndash;      </li>&ndash;&gt;-->
<!--            </ul>-->
<!--        </div>-->
<!--        <table mat-table [dataSource]="dataSource" class="  example-container">-->

<!--            &lt;!&ndash;- Note that these columns can be defined in any order.-->
<!--                  The actual rendered columns are set as a property on the row definition" &ndash;&gt;-->

<!--            &lt;!&ndash; Position Column &ndash;&gt;-->
<!--            <ng-container matColumnDef="position">-->
<!--                <th mat-header-cell *matHeaderCellDef> No.</th>-->
<!--                <td mat-cell *matCellDef="let element"> {{element.position}} </td>-->
<!--            </ng-container>-->

<!--            &lt;!&ndash; Name Column &ndash;&gt;-->
<!--            <ng-container matColumnDef="children">-->
<!--                <th mat-header-cell *matHeaderCellDef>Name</th>-->
<!--                <td mat-cell *matCellDef="let element">{{element.childName}} </td>-->
<!--            </ng-container>-->

<!--            &lt;!&ndash; Weight Column &ndash;&gt;-->
<!--            <ng-container matColumnDef="centre">-->
<!--                <th mat-header-cell *matHeaderCellDef> Centre</th>-->
<!--                <td mat-cell *matCellDef="let element">{{element.centreName}} </td>-->
<!--            </ng-container>-->
<!--            &lt;!&ndash; Weight Column &ndash;&gt;-->
<!--            <ng-container matColumnDef="dateOfAssessment">-->
<!--                <th mat-header-cell *matHeaderCellDef> Assessment Date</th>-->
<!--                <td mat-cell *matCellDef="let element">{{element.dateOfAssessment.toDate() | date :'dd/MM/yyyy'}} </td>-->
<!--            </ng-container>-->


<!--            <ng-container matColumnDef="action">-->
<!--                <th mat-header-cell *matHeaderCellDef>Action</th>-->
<!--                <td mat-cell *matCellDef="let element">-->
<!--                    &nbsp; <button  mat-icon-button color="accent" matTooltip="View" (click)="viewDialog(element)" >-->
<!--                        <mat-icon>remove_red_eye</mat-icon>-->
<!--                    </button>-->
<!--                &nbsp;    <button mat-icon-button color="primary" (click)="viewEdit(element)" matTooltip="Edit">-->
<!--                        <mat-icon>edit</mat-icon>-->
<!--                    </button>-->
<!--                    &nbsp;  <button mat-icon-button color="warn" (click)="deleteChild(element)" matTooltip="Delete">-->
<!--                        <mat-icon>delete</mat-icon>-->
<!--                    </button>-->

<!--                </td>-->
<!--            </ng-container>-->


<!--            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>-->
<!--            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
<!--        </table>-->
<!--        <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]"-->
<!--                       showFirstLastButtons-->
<!--                       aria-label="Select page">-->
<!--        </mat-paginator>-->
<!--    </div>-->
    <section   >
        <mat-accordion>
            <mat-expansion-panel *ngFor="let d of mData" >
                <mat-expansion-panel-header>
                    <mat-panel-title>
<div class="d-flex justify-content-center">
    <div>{{d.childName}}</div>
</div>
                    </mat-panel-title>
                    <mat-panel-description>

                        <div>   {{d.sessionType}} ({{d.dateOfAssessment.toDate()|date:'dd-MM-yyyy'}})</div>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                   <div *ngFor="let q of d.questions">
                       <div class="font-bold">{{q.question}}</div>
                       <div >{{q.ans}}</div>
                       <div >{{q.remark}}</div>
                   </div>

            </mat-expansion-panel>

        </mat-accordion>


    </section>

</div>
